// extracted by mini-css-extract-plugin
module.exports = {"article":"styles-module__article___2pGp1"};